export const TSHIRT_DECK = ['xs', 's', 'm', 'l', 'xl', 'xxl', '?', '☕'] as const;

export type TShirtSize = 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';

export const TSHIRT_ORDER: TShirtSize[] = ['xs', 's', 'm', 'l', 'xl', 'xxl'];

export function isValidTShirtCard(card: string): boolean {
  return (TSHIRT_DECK as readonly string[]).includes(card);
}

export function isTShirtSize(value: string): value is TShirtSize {
  return (TSHIRT_ORDER as string[]).includes(value);
}

/** Mode of size votes; ties broken by picking the larger size. Returns null if no size votes. */
export function getMostCommonSize(votes: string[]): TShirtSize | null {
  const counts = new Map<TShirtSize, number>();
  votes.forEach(v => {
    if (isTShirtSize(v)) {
      counts.set(v, (counts.get(v) || 0) + 1);
    }
  });
  if (counts.size === 0) return null;

  let best: TShirtSize | null = null;
  let bestCount = -1;
  TSHIRT_ORDER.forEach(size => {
    const c = counts.get(size) || 0;
    if (c === 0) return;
    // Tie → prefer larger size (later in TSHIRT_ORDER, so >= wins).
    if (c > bestCount || (c === bestCount && best !== null)) {
      best = size;
      bestCount = c;
    }
  });
  return best;
}
